var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { omitAdditionalInfoFields, removeAdditionalInfoArrayTail, serializeAdditionalInfo, shortenAdditionalInfoText, } from "@payair/e-com-common-sdk/core/AdditionalInfoSerializer";
import { SrciEventTypeEnumsObj } from "../../enums/SrciEventTypeEnum";
var isRecord = function (value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
};
var stringValue = function (value) {
    return typeof value === "string" && value.length > 0 ? value : undefined;
};
var numericStatus = function (value) {
    if (typeof value === "number" && Number.isFinite(value))
        return value;
    if (typeof value !== "string" || value.trim() === "")
        return undefined;
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
};
var addDefined = function (payload, field, value) {
    if (value !== undefined && value !== null && value !== "")
        payload[field] = value;
};
var serializationFailure = function () { return ({ additionalInfoError: "SERIALIZATION_FAILED" }); };
export var getErrorMessage = function (error) {
    try {
        return isRecord(error) ? stringValue(error.message) : undefined;
    }
    catch (_error) {
        return undefined;
    }
};
export var buildReasonTelemetry = function (reason, context, message) {
    if (context === void 0) { context = {}; }
    var payload = {};
    addDefined(payload, "operation", context.operation);
    addDefined(payload, "stage", context.stage);
    addDefined(payload, "network", context.network);
    addDefined(payload, "reason", reason);
    addDefined(payload, "message", message);
    return payload;
};
export var buildUnexpectedExceptionTelemetry = function (context, error) {
    return buildReasonTelemetry("UNEXPECTED_EXCEPTION", context, getErrorMessage(error));
};
export var buildDcfTelemetry = function (source, context, mappedReason) {
    var _a, _b, _c;
    if (context === void 0) { context = {}; }
    try {
        var result = isRecord(source) ? source : undefined;
        var reasonSource = result === null || result === void 0 ? void 0 : result.reason;
        var reason = isRecord(reasonSource) ? reasonSource : undefined;
        var rawReason = reason ? stringValue(reason.reason) : stringValue(reasonSource);
        var status_1 = reason === null || reason === void 0 ? void 0 : reason.status;
        var statusNumber = numericStatus(status_1);
        var dcfStatus = statusNumber === undefined ? stringValue(status_1) : undefined;
        var httpStatus = statusNumber !== null && statusNumber !== void 0 ? statusNumber : (dcfStatus ? numericStatus(reason === null || reason === void 0 ? void 0 : reason.code) : undefined);
        var payload = {};
        addDefined(payload, "operation", context.operation);
        addDefined(payload, "stage", context.stage);
        addDefined(payload, "network", (_b = (_a = context.network) !== null && _a !== void 0 ? _a : stringValue(result === null || result === void 0 ? void 0 : result.sdk)) !== null && _b !== void 0 ? _b : stringValue(result === null || result === void 0 ? void 0 : result.dcf));
        addDefined(payload, "httpStatus", httpStatus);
        addDefined(payload, "dcfStatus", dcfStatus);
        addDefined(payload, "reason", rawReason);
        if (mappedReason && mappedReason !== rawReason)
            addDefined(payload, "mappedReason", mappedReason);
        var candidateResultValue = result === null || result === void 0 ? void 0 : result.value;
        var resultValue = isRecord(candidateResultValue) ? candidateResultValue : undefined;
        var candidateCheckoutResponse = resultValue === null || resultValue === void 0 ? void 0 : resultValue.checkoutResponse;
        var checkoutResponse = isRecord(candidateCheckoutResponse) ? candidateCheckoutResponse : undefined;
        addDefined(payload, "srcCorrelationId", (_c = stringValue(resultValue === null || resultValue === void 0 ? void 0 : resultValue.srcCorrelationId)) !== null && _c !== void 0 ? _c : stringValue(checkoutResponse === null || checkoutResponse === void 0 ? void 0 : checkoutResponse.srcCorrelationId));
        addDefined(payload, "message", reason ? stringValue(reason.message) : undefined);
        return payload;
    }
    catch (_error) {
        return serializationFailure();
    }
};
export var buildDcfActionTelemetry = function (source, network, context) {
    var _a, _b, _c, _d;
    if (context === void 0) { context = {}; }
    try {
        var checkout = isRecord(source) ? source : undefined;
        var candidateCheckoutResponse = checkout === null || checkout === void 0 ? void 0 : checkout.checkoutResponse;
        var checkoutResponse = isRecord(candidateCheckoutResponse) ? candidateCheckoutResponse : undefined;
        var payload = {};
        addDefined(payload, "operation", context.operation);
        addDefined(payload, "stage", (_a = context.stage) !== null && _a !== void 0 ? _a : "DCF_ACTION");
        addDefined(payload, "network", (_b = context.network) !== null && _b !== void 0 ? _b : network);
        addDefined(payload, "dcfActionCode", (_d = stringValue((_c = checkout === null || checkout === void 0 ? void 0 : checkout.dcfActionCode) !== null && _c !== void 0 ? _c : source)) !== null && _d !== void 0 ? _d : "INVALID_RESPONSE");
        addDefined(payload, "srcCorrelationId", stringValue(checkoutResponse === null || checkoutResponse === void 0 ? void 0 : checkoutResponse.srcCorrelationId));
        return payload;
    }
    catch (_error) {
        return serializationFailure();
    }
};
export var buildBackendErrorTelemetry = function (params) {
    var _a;
    try {
        var context = params.context || {};
        var normalizedErrors = params.errors.reduce(function (result, error) {
            var errorCode = stringValue(error === null || error === void 0 ? void 0 : error.errorCode);
            var reasonCode = stringValue(error === null || error === void 0 ? void 0 : error.reasonCode);
            if (!errorCode || !reasonCode)
                return result;
            if (!result.some(function (item) { return item.errorCode === errorCode && item.reasonCode === reasonCode; })) {
                result.push({ errorCode: errorCode, reasonCode: reasonCode });
            }
            return result;
        }, []);
        var payload = {};
        addDefined(payload, "operation", context.operation);
        addDefined(payload, "stage", (_a = context.stage) !== null && _a !== void 0 ? _a : "CHECKOUT_TRANSACTION");
        addDefined(payload, "network", context.network);
        addDefined(payload, "httpStatus", typeof params.httpStatus === "number" && Number.isFinite(params.httpStatus) ? params.httpStatus : undefined);
        payload.errors = normalizedErrors;
        if (params.errors.length >= 2)
            payload.errorCount = params.errors.length;
        addDefined(payload, "srcCorrelationId", stringValue(params.srcCorrelationId));
        var description_1;
        params.errors.some(function (error) {
            description_1 = stringValue(error === null || error === void 0 ? void 0 : error.description);
            return description_1 !== undefined;
        });
        addDefined(payload, "description", description_1);
        return payload;
    }
    catch (_error) {
        return serializationFailure();
    }
};
export var buildRequired3dsTelemetry = function (params) {
    var _a;
    try {
        var response = params.response;
        var context = params.context || {};
        var payload = {};
        addDefined(payload, "operation", context.operation);
        addDefined(payload, "stage", (_a = context.stage) !== null && _a !== void 0 ? _a : "3DS");
        addDefined(payload, "network", context.network);
        addDefined(payload, "transactionReference", stringValue(response.transactionReference));
        addDefined(payload, "srcCorrelationId", stringValue(params.srcCorrelationId));
        addDefined(payload, "paymentNetworkReference", stringValue(response.paymentNetworkReference));
        addDefined(payload, "networkTransactionIdentifier", stringValue(response.networkTransactionIdentifier));
        addDefined(payload, "networkAuthorizationCode", stringValue(response.networkAuthorizationCode));
        var transactionAmount = stringValue(response.transactionAmount);
        var transactionCurrencyCode = stringValue(response.transactionCurrencyCode);
        if (transactionAmount && transactionCurrencyCode) {
            payload.transactionAmount = transactionAmount;
            payload.transactionCurrencyCode = transactionCurrencyCode;
        }
        addDefined(payload, "addressVerification", stringValue(response.addressVerification));
        return payload;
    }
    catch (_error) {
        return serializationFailure();
    }
};
export var buildProfileSuccessTelemetry = function (network) { return ({ network: network }); };
export var buildDcfErrorsTelemetry = function (sources, context) {
    if (context === void 0) { context = {}; }
    try {
        var errors = [];
        for (var _i = 0, sources_1 = sources; _i < sources_1.length; _i++) {
            var source = sources_1[_i];
            var error = buildDcfTelemetry(source, context);
            if (error.additionalInfoError === "SERIALIZATION_FAILED")
                return serializationFailure();
            if (Object.keys(error).length > 0)
                errors.push(error);
        }
        return __assign({ errors: errors }, (sources.length > 1 ? { errorCount: sources.length } : {}));
    }
    catch (_error) {
        return serializationFailure();
    }
};
export var buildUnbindErrorTelemetry = function (sources) {
    return buildDcfErrorsTelemetry(sources);
};
var omitNestedMessages = function (payload) {
    if (!Array.isArray(payload.errors))
        return payload;
    return __assign(__assign({}, payload), { errors: payload.errors.map(function (error) {
            if (!isRecord(error))
                return error;
            var copy = __assign({}, error);
            delete copy.message;
            return copy;
        }) });
};
var getReductions = function (eventType, payload) {
    if (eventType === SrciEventTypeEnumsObj.PAYMENT_COMPLETION_REQUIRED_3DS) {
        return [
            omitAdditionalInfoFields("addressVerification"),
            omitAdditionalInfoFields("transactionAmount", "transactionCurrencyCode"),
            omitAdditionalInfoFields("networkAuthorizationCode"),
            omitAdditionalInfoFields("networkTransactionIdentifier"),
            omitAdditionalInfoFields("paymentNetworkReference"),
            omitAdditionalInfoFields("srcCorrelationId"),
            omitAdditionalInfoFields("transactionReference"),
        ];
    }
    if (Array.isArray(payload.errors)) {
        return [
            shortenAdditionalInfoText("description"),
            omitAdditionalInfoFields("description"),
            omitAdditionalInfoFields("srcCorrelationId"),
            omitNestedMessages,
            removeAdditionalInfoArrayTail("errors", 1),
        ];
    }
    return [
        shortenAdditionalInfoText("message"),
        omitAdditionalInfoFields("message"),
        omitAdditionalInfoFields("srcCorrelationId"),
        omitAdditionalInfoFields("mappedReason"),
    ];
};
export var serializeSrciTelemetry = function (eventType, payload) {
    if (payload === undefined)
        return null;
    if (!isRecord(payload))
        return serializeAdditionalInfo(serializationFailure());
    try {
        return serializeAdditionalInfo(payload, getReductions(eventType, payload));
    }
    catch (_error) {
        return serializeAdditionalInfo(serializationFailure());
    }
};
